import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Public from "./utils/common";
import {
    Layout,
    Tabs,
    Form,
    Input,
    InputNumber,
    Button,
    Icon,
    Checkbox,
    Alert,
    Menu,
    Dropdown,
    Avatar,
    Breadcrumb,
    Table,
    Collapse,
    Tag,
    Divider,
    PageHeader,
    Modal,
    message,
    Row,
    Col,
    Space,
    Upload,
    Select,
    Radio,
    Tree,
    TreeSelect,
    Card,
    Empty,
    Spin,
    Switch,
    DatePicker,
    Descriptions,
    Badge,
    Statistic,
    List,
    ConfigProvider,
    Carousel,
    Steps,
    Timeline,
    Popconfirm,
    Progress,
    Cascader,
    Popover
} from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import "nprogress/nprogress.css";

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import icon from "../src/assets/iconfront/iconfont.css";
Vue.use(icon);

import { setCookie, getCookie, delCookie } from "./utils/cookie";
Vue.prototype.$cookieStore = { setCookie, getCookie, delCookie };

Vue.config.productionTip = true;
Vue.config.errorHandler = function(err) {
    console.log("global", err);
    message.error("出错了，请联系技术支持");
};
message.config({
    top: `80px`
});
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;

Vue.use(Public);
Vue.prototype.$Public = Public;

Vue.use(Layout);
Vue.use(Tabs);
Vue.use(Form);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Checkbox);
Vue.use(Alert);
Vue.use(Menu);
Vue.use(Dropdown);
Vue.use(Avatar);
Vue.use(Breadcrumb);
Vue.use(Table);
Vue.use(Collapse);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(PageHeader);
Vue.use(Modal);
Vue.use(Row);
Vue.use(Col);
Vue.use(Space);
Vue.use(Upload);
Vue.use(Select);
Vue.use(Radio);
Vue.use(Tree);
Vue.use(TreeSelect);
Vue.use(Card);
Vue.use(Empty);
Vue.use(Spin);
Vue.use(Switch);
Vue.use(DatePicker);
Vue.use(Descriptions);
Vue.use(Badge);
Vue.use(Statistic);
Vue.use(List);
Vue.use(ConfigProvider);
Vue.use(Carousel);
Vue.use(Steps);
Vue.use(Timeline);
Vue.use(Popconfirm);
Vue.use(Collapse);
Vue.use(Progress);
Vue.use(Cascader);
Vue.use(Popover);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
